"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardNodeHash = exports.standardLeafHash = void 0;
const abi_1 = require("@ethersproject/abi");
const keccak256_1 = require("@ethersproject/keccak256");
const bytes_1 = require("./bytes");
function standardLeafHash(types, value) {
    return (0, keccak256_1.keccak256)((0, keccak256_1.keccak256)(abi_1.defaultAbiCoder.encode(types, value)));
}
exports.standardLeafHash = standardLeafHash;
function standardNodeHash(a, b) {
    return (0, keccak256_1.keccak256)((0, bytes_1.concat)([a, b].sort(bytes_1.compare)));
}
exports.standardNodeHash = standardNodeHash;
//# sourceMappingURL=hashes.js.map